import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  CircularProgress,
  Alert,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCameraRetro } from "@fortawesome/free-solid-svg-icons";
import { storage, db } from "../../../../config/firebase"; // Adjust the path as needed
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import ModalDialogTitle from "../../../common/ModalDialogTitle";
import ModalActions from "../../../common/ModalActions";

const Avatar = ({ user, onAvatarUploadSuccess }) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setFile(null);
    setError("");
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (
      selectedFile &&
      (selectedFile.type === "image/png" || selectedFile.type === "image/jpeg")
    ) {
      setFile(selectedFile);
      setError("");
    } else {
      setError("Please select a PNG or JPG image.");
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      setError("Please select a file.");
      return;
    }

    setLoading(true);
    try {
      const storageRef = ref(storage, `avatars/${file.name}`);
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);

      const userRef = doc(db, "users", user.id);
      await updateDoc(userRef, { avatar: downloadURL });

      if (typeof onAvatarUploadSuccess === "function") {
        onAvatarUploadSuccess();
      }

      handleClose();
    } catch (error) {
      setError("Error uploading file. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <FontAwesomeIcon
        icon={faCameraRetro}
        style={{ color: "teal", cursor: "pointer" }}
        onClick={handleOpen}
        size="2x"
      />
      <Dialog open={open} onClose={handleClose}>
        <ModalDialogTitle onClose={handleClose}>
          Upload New Avatar
        </ModalDialogTitle>
        <DialogContent>
          <input
            type="file"
            accept="image/png, image/jpeg"
            onChange={handleFileChange}
          />
          {error && <Alert severity="error">{error}</Alert>}
          {loading && (
            <Box display="flex" justifyContent="center" mt={2}>
              <CircularProgress />
            </Box>
          )}
        </DialogContent>
        <ModalActions onSave={handleSubmit} saving={loading} saveLabel="Upload" />
      </Dialog>
    </div>
  );
};

export default Avatar;
